// Episode list for the quiz flow. Generated from episodes.txt — source of truth.
export interface Episode {
  /** Episode number (2–8). */
  n: number;
  title: string;
}

export const EPISODES: readonly Episode[] = [
  { n: 2, title: 'The Practice' },
  { n: 3, title: 'The Orgasm' },
  { n: 4, title: 'The Breakup' },
  { n: 5, title: 'The Cold Turkey' },
  { n: 6, title: 'The Breakaway' },
  { n: 7, title: 'The Faceoff' },
  { n: 8, title: 'The Line Change' },
] as const;

export function episodeTitle(n: number): string {
  return EPISODES.find((e) => e.n === n)?.title ?? '';
}
